import { render, staticRenderFns } from "./cards-tables.vue?vue&type=template&id=a4e4573a&scoped=true"
import script from "./cards-tables.vue?vue&type=script&lang=js"
export * from "./cards-tables.vue?vue&type=script&lang=js"
import style0 from "./cards-tables.vue?vue&type=style&index=0&id=a4e4573a&prod&lang=css"
import style1 from "./cards-tables.vue?vue&type=style&index=1&id=a4e4573a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4e4573a",
  null
  
)

export default component.exports